import { computed, defineComponent, inject } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import Quantity from "../../Shared/Quantity";
import { orderServiceKey } from "../../../infrastructure/gfo_api/order_service";
import { priceFormatterKey } from "../../../infrastructure/price_formatter";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

const PRODUCT_ID_NUMBERS = 20;
const PRODUCT_ID_ADDITIONAL_NUMBER = 21;

export default defineComponent({
  template: html,
  components: { Quantity },
  setup() {
    // Injections
    const { t } = useI18n();
    const orderService = inject(orderServiceKey);
    const priceFormatter = inject(priceFormatterKey);

    // variables and computed
    const numbersCartItem = computed(() => {
      return orderService?.currentItems?.value?.find(
        (it) => it.product_id == PRODUCT_ID_NUMBERS,
      ) ?? null;
    });
    const numbersVariant = computed(() => {
      const item = numbersCartItem.value;
      if (!item) {
        return null;
      }
      return orderService?.availableVariants?.value?.find(
        (v) => v.id == item.product_variant_id,
      ) ?? null;
    });
    const numbersIncluded = computed(() => numbersVariant.value?.numbers_included ?? 0);
    const numbersMax = computed(() => numbersVariant.value?.numbers_max ?? 0);

    const additionalNumberVariant = computed(() => {
      return orderService?.availableVariants?.value?.find(
        (v) => v.product_id == PRODUCT_ID_ADDITIONAL_NUMBER && v.qty_price_for == 0,
      ) ?? null;
    });
    const additionalNumberVariants = computed(() => {
      const variants = orderService?.availableVariants?.value?.filter(
        (v) => v.product_id == PRODUCT_ID_ADDITIONAL_NUMBER,
      ) ?? [];
      return [...variants].sort((a, b) => {
        if (a.qty_price_for == 0 && b.qty_price_for != 0) {
          return -1;
        }
        if (a.qty_price_for != 0 && b.qty_price_for == 0) {
          return 1;
        }
        return (a.qty_max ?? 0) - (b.qty_max ?? 0);
      });
    });
    const currentAdditionalNumberQuantity = computed(() => {
      return orderService?.currentItems?.value?.reduce((sum, it) => {
        if (it.product_variant_id == additionalNumberVariant.value?.id) {
          sum = sum + it.qty;
        }
        return sum;
      }, 0) ?? 0;
    });
    const totalNumbersQuantity = computed(() => numbersIncluded.value + currentAdditionalNumberQuantity.value);
    const vatType = computed(() => {
      return orderService?.currentVatType.value;
    });

    // methods
    const handleAdditionalNumberQuantityChange = async (qty: number) => {
      const diff = qty - totalNumbersQuantity.value;
      const variantId = additionalNumberVariant.value?.id ?? 0;
      if (diff > 0) {
        await orderService?.addToCart(variantId, "", diff);
      } else if (diff < 0) {
        await orderService?.removeFromCart(variantId, "", (-1) * diff);
      }
    };

    return {
      t,
      numbersVariant,
      numbersIncluded,
      numbersMax,
      additionalNumberVariant,
      additionalNumberVariants,
      totalNumbersQuantity,
      handleAdditionalNumberQuantityChange,
      priceFormatter,
      vatType,
    };
  },
} as any);
